import { Outlet } from 'react-router-dom';
import { AppNavbar } from '@/components/layout/AppNavbar';
import { AppFooter } from '@/components/layout/AppFooter';
import { ViewAsBanner } from '@/components/layout/ViewAsBanner';
import { NotificationBell } from '@/features/notifications/components/NotificationBell';
import { MAIN_CONTENT_ID } from '@/lib/constants/layout';
import { useHasInProgressStartupDraft } from '@/features/startups/hooks/useHasInProgressStartupDraft';

export function AppLayout() {
  const hasInProgressStartupDraft = useHasInProgressStartupDraft();
  return (
    <div className="min-h-screen flex flex-col bg-[#F7F9FB]">
      {/* Above the navbar so it is the first thing on every screen of a view-as tab (MYN-335). */}
      <ViewAsBanner />
      <AppNavbar rightSlot={<NotificationBell />} hasInProgressStartupDraft={hasInProgressStartupDraft} />
      {/* The arbitrary-property class publishes how much height this shell's
        chrome already takes, so a routed state that owns the whole screen can
        center itself in what is left (`FULL_SCREEN_STATE_MIN_H`) - and the same
        state stays correct when rendered with no shell at all, where it
        inherits the `0px` root default instead. Purely a custom property: it
        declares nothing about this element's own display, height, or overflow,
        so nothing that does not read it is affected. */}
      <main
        className="flex-1 overflow-auto [--app-chrome-offset:var(--spacing-app-navbar)]"
        id={MAIN_CONTENT_ID}
      >
        <Outlet />
      </main>
      {/* Footer on the dashboard and every internal page (UX sheet,
          StartupAdminVF r50). Its own logged-in footer with support contact and
          internal links (MYN-253), not the public marketing one (MYN-220). */}
      <AppFooter />
    </div>
  );
}
